module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2ZXJzaW9uPSIxIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiM0OTkzNDgiIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjxwYXRoIGZpbGw9IiNDRjM3MzciIGQ9Ik0xMjggMHYxMjhIMEwxMjggMHoiLz48dGV4dCBmaWxsPSIjRkZGRkZGIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iNjQiPjx0c3BhbiB4PSIzNSIgeT0iODUiPklUPC90c3Bhbj48L3RleHQ+PC9nPjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/language-icons/icons/it.svg
// module id = CYcw
// module chunks = 1